import { useEditor } from '@tiptap/react';

import { loadExtensions } from '../functions';
import { tipTapPluginsMode } from '../constants';

export type UseEditorSetupPropsType = {
  content?: string;
  editable?: boolean;
  placeholder?: string;
  pluginsMode: tipTapPluginsMode;
  isHtmlMode?: boolean;
  isOnFocus?: boolean;
  onChange?: any;
};

export const useEditorSetup = ({
  content,
  editable,
  placeholder,
  pluginsMode,
  isHtmlMode,
  isOnFocus,
  onChange,
}: UseEditorSetupPropsType) => {
  const extensions = loadExtensions({ mode: pluginsMode, placeholder });

  const editor = useEditor({
    content,
    extensions,
    editable,
    onUpdate: ({ editor }) => {
      const htmlContent = editor.getHTML();
      const textContent = editor.getText();

      const updatedContent = isHtmlMode ? htmlContent : textContent;
      onChange(updatedContent);
    },
    autofocus: isOnFocus,
  });

  return editor;
};
